import React from 'react'
import LeadsList from './leads'
import LeadsListIndividual from './leadsIndividual'

function LeadsMain() {
  const role = JSON.parse((localStorage.getItem('kt-auth-react-v') as any) || {})?.data?.role?.role_id

  // console.log(role)
  return <>{role === 1 || role === 2 ? <LeadsList /> : <LeadsListIndividual />}</>
}

export default LeadsMain
